module.exports = __webpack_public_path__ + "static/media/382JamesPBrawleyDrNW_2018-06-11_76.cb4b544c.jpg";